<template>
  <el-tooltip effect="dark" :content="item.label" placement="top">
    <div class="padding-5 pointer flex-center" @click="changeScreen">
      <img :src="item.icon" :style="{ width: item.size + 'px', height: item.size + 'px' }" />
    </div>
  </el-tooltip>
</template>
<script >
import { inject } from '@vue/composition-api';
import { useFullScreen } from '@/hooks';
const __sfc_main = {};
__sfc_main.props = {
  item: {
    type: Object,
    default: () => {}
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    setFullScreenToggle,
    isFullScreen,
    onChange
  } = useFullScreen();
  const tableContainer = inject('tableContainer');
  const isTableFullScreen = inject('isTableFullScreen');
  const changeScreen = () => {
    if (tableContainer.value) {
      const el = document.body;
      setFullScreenToggle(el, {
        navigationUI: 'show'
      });
      const time = setTimeout(() => {
        if (isFullScreen()) {
          tableContainer.value.style.zIndex = 9999;
        } else {
          tableContainer.value.style.zIndex = 10;
        }
        clearTimeout(time);
      }, 50);
    }
  };
  onChange(e => {
    isTableFullScreen.value = isFullScreen();
    if (!isFullScreen()) {
      tableContainer.value.style.zIndex = 10;
    }
  });
  return {
    changeScreen
  };
};
export default __sfc_main;
</script>
<style scoped lang="scss"></style>
